import {
  Building2, Boxes, Layers, Cable, MessageSquare, Gauge, Network, Globe2,
} from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useI18n } from "@/i18n";

const ICONS = [Building2, Boxes, Layers, Cable, MessageSquare, Gauge, Network, Globe2];

export default function WhyUs() {
  const { t } = useI18n();
  const cards = t("why.cards") || [];
  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-32 noise">
      <div className="glow-blue" style={{ width: 520, height: 520, left: -160, top: 200, background: "radial-gradient(circle at center, rgba(22,75,255,0.3), transparent 60%)" }} />
      <div className="glow-blue" style={{ width: 520, height: 520, right: -160, bottom: 100, background: "radial-gradient(circle at center, rgba(122,92,255,0.28), transparent 60%)" }} />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          testId="why-heading"
          eyebrow={t("why.eyebrow")}
          title={<>
            {t("why.title_a")}{" "}
            <span className="text-gradient-brand">{t("why.title_b")}</span>{" "}
            {t("why.title_c")}
          </>}
          subtitle={t("why.subtitle")}
          align="center"
        />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, i) => {
            const Icon = ICONS[i] || Building2;
            return (
              <div key={i} data-testid={`why-card-${i}`} className="glass-card rounded-2xl p-6 reveal" style={{ transitionDelay: `${(i % 4) * 70}ms` }}>
                <div className="icon-bubble mb-5" style={{ color: "#C4B6FF" }}><Icon className="w-5 h-5" /></div>
                <h3 className="font-display text-[16.5px] font-semibold tracking-tight text-white">{card.title}</h3>
                <p className="mt-2 text-[13.5px] text-[#A8A8B3] leading-relaxed">{card.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
